import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var supported_media = lang.audio_html_info_supported_media
if(instagram_addon) supported_media = lang.audio_html_info_supported_media_ig

export const audioHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.audio_html_label_media_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.audio_html_ph_media_url + '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
  '<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
    '<div class="dz-default dz-message">' +
      '<input type="file" class="d-none" name="uploaded-file-audio" id="uploaded-file-audio">' +
      '<i class="fas fa-cloud-upload-alt"></i>' +
    '</div>' +
  '</div>' +
  '<span class="text-small text-muted">' + supported_media + '</span>' +
'</div>' +

// Adds html for delay system
delayHtml